module.exports = __webpack_public_path__ + "static/media/gaetano2.726c942a.jpg";